<template>
  <div
    id="sidenav-collapse-main"
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100 bg-gradient-green1"
  >
    <ul class="navbar-nav">
      <li v-if="canAccessVehicles" class="nav-item Vehiculos">
        <sidenav-collapse
          collapse-ref="vehiculos"
          nav-text="Vehículos"
        >
          <template #icon>
            <i class="material-icons text-white">directions_car</i>
          </template>
          <template #list>
            <ul class="nav pe-0 ms-3">
              <sidenav-item
                :to="{ name: 'GestionAutos' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjkyIDYuMDFDMTguNzIgNS40MiAxOC4xNiA1IDE3LjUgNUg2LjVDNS44NCA1IDUuMjggNS40MiA1LjA4IDYuMDFMMyA5VjE5QzMgMTkuNTUgMy40NSAyMCA0IDIwSDUuMUM1LjY1IDIwIDYuMiAxOS41NSA2LjIgMTlWMTcuNUgxNy44VjE5QzE3LjggMTkuNTUgMTguMzUgMjAgMTguOSAyMEgyMEMyMC41NSAyMCAyMSAxOS41NSAyMSAxOVY5TDE4LjkyIDYuMDFaTTYuNSAxNS41QzUuNjcgMTUuNSA1IDE0LjgzIDUgMTRTNS42NyAxMi41IDYuNSAxMi41UzggMTMuMTcgOCAxNFM3LjMzIDE1LjUgNi41IDE1LjVaTTE3LjUgMTUuNUMxNi42NyAxNS41IDE2IDE0LjgzIDE2IDE0UzE2LjY3IDEyLjUgMTcuNSAxMi41UzE5IDEzLjE3IDE5IDE0UzE4LjMzIDE1LjUgMTcuNSAxNS41Wk0xOC45MiA2SDE3LjVMMTguOTIgNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
                text="Listado de Vehículos"
                :activo="getRoute() === 'GestionAutos'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionVentasVehiculos' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDRIMEMyLjg5IDQgMiA0LjkgMiA2VjE4QzIgMTkuMTEgMi44OSAyMCA0IDIwSDIwQzIxLjExIDIwIDIyIDE5LjExIDIyIDE4VjZDMjIgNC44OSAyMS4xMSA0IDIwIDRaTTIwIDE4SDRWNkg4VjE4SDRWMTBIMjBWMThaTTEwIDEySDE2VjE0SDEwVjEyWk0xMCA4SDE2VjEwSDEwVjhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Venta de Vehículos"
                :activo="getRoute() === 'GestionVentasVehiculos'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionVehiculosRecuperados' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTIgMjBDNy41OCAyMCA0IDE2LjQyIDQgMTJDNCA3LjU4IDcuNTggNCAxMiA0QzE2LjQyIDQgMjAgNy41OCAyMCAxMkMyMCAxNi40MiAxNi40MiAyMCAxMiAyMFpNMTMgMTdIN1YxNUgxM1YxN1pNMTcgMTNIN1YxMUgxN1YxM1pNMTcgOUg3VjdIMTdWOVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
                text="Vehículos Recuperados"
                :activo="getRoute() === 'GestionVehiculosRecuperados'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionAutosEliminados' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMTlDNiAyMC4xIDYuOSAyMSA4IDIxSDE2QzE3LjEgMjEgMTggMjAuMSAxOCAxOVY3SDZWMThaTTggOUgxNlYxOUg4VjlaTTE1LjUgNEgxNC41TDEzLjUgNUgxMC41TDkuNSA0SDguNUM3LjY3IDQgNyA0LjY3IDcgNS41VjZIMTdWNS41QzE3IDQuNjcgMTYuMzMgNCAxNS41IDRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Vehículos Eliminados"
                :activo="getRoute() === 'GestionAutosEliminados'"
                @click="cerrar_menu"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="canAccessQuotes" class="nav-item Cotizaciones">
        <sidenav-collapse
          collapse-ref="cotizaciones"
          nav-text="Cotizaciones"
        >
          <template #icon>
            <i class="material-icons text-white">request_quote</i>
          </template>
          <template #list>
            <ul class="nav pe-0 ms-3">
              <sidenav-item
                :to="{ name: 'GestionCotizaciones' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDJINkMyLjY5IDIgMiAyLjY5IDIgNlYxOEMyIDE5LjMxIDIuNjkgMjAgNCAyMEgxOEMxOS4zMSAyMCAyMCAxOS4zMSAyMCAxOFY4TDE0IDJaTTE4IDE4SDZWNkgxM1Y5SDE4VjE4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="
                text="Listado"
                :activo="getRoute() === 'GestionCotizaciones'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'CotizacionesCanceladas' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaTTE1LjcxIDEwLjI5TDEzLjQxIDhMMTUuNzEgNS43MUwxNC4yOSA0LjI5TDEyIDYuNTlMOS43MSA0LjI5TDguMjkgNS43MUwxMC41OSA4TDguMjkgMTAuMjlMOS43MSAxMS43MUwxMiA5LjQxTDE0LjI5IDExLjcxTDE1LjcxIDEwLjI5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="
                text="Canceladas"
                :activo="getRoute() === 'CotizacionesCanceladas'"
                @click="cerrar_menu"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="canAccessManagement" class="nav-item Gestion">
        <sidenav-collapse
          collapse-ref="gestion"
          nav-text="Gestión"
        >
          <template #icon>
            <i class="material-icons text-white">business_center</i>
          </template>
          <template #list>
            <ul class="nav pe-0 ms-3">
              <sidenav-item
                :to="{ name: 'GestionClientes' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDEyQzE0LjIxIDEyIDE2IDEwLjIxIDE2IDhDMTYgNS43OSAxNC4yMSA0IDEyIDRDOS43OSA0IDggNS43OSA4IDhDOCAxMC4yMSA5Ljc5IDEyIDEyIDEyWk0xMiAxNEM5LjMzIDE0IDQgMTUuMzQgNCAxOFYyMEgyMFYxOEMyMCAxNS4zNCAxNC42NyAxNCAxMiAxNFoi IGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
                text="Clientes"
                :activo="getRoute() === 'GestionClientes'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionContratos' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDJINkMyLjY5IDIgMiAyLjY5IDIgNlYxOEMyIDE5LjMxIDIuNjkgMjAgNCAyMEgxOEMxOS4zMSAyMCAyMCAxOS4zMSAyMCAxOFY4TDE0IDJaTTE4IDE4SDZWNkgxM1Y5SDE4VjE4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="
                text="Contratos"
                :activo="getRoute() === 'GestionContratos'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionGestores' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDEyQzE0LjIxIDEyIDE2IDEwLjIxIDE2IDhDMTYgNS43OSAxNC4yMSA0IDEyIDRDOS43OSA0IDggNS43OSA4IDhDOCAxMC4yMSA5Ljc5IDEyIDEyIDEyWk0xMiAxNEM5LjMzIDE0IDQgMTUuMzQgNCAxOFYyMEgyMFYxOEMyMCAxNS4zNCAxNC42NyAxNCAxMiAxNFoi IGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
                text="Gestores WhatsApp"
                :activo="getRoute() === 'GestionGestores'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionCalendarioPagos' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDNIMThWMUgxNlYzSDhWMWgtMlYzSDVDMy44OSAzIDMuMDEgMy45IDMuMDEgNUwzIDE5QzMgMjAuMSAzLjg5IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xOSAxOUg1VjhIMTlWMTlaTTcgMTBIMTJWMjJIN1YxMFoi IGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
                text="Calendario de Pagos"
                :activo="getRoute() === 'GestionCalendarioPagos'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionPagos' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDRIMEMyLjg5IDQgMiA0LjkgMiA2VjE4QzIgMTkuMTEgMi44OSAyMCA0IDIwSDIwQzIxLjExIDIwIDIyIDE5LjExIDIyIDE4VjZDMjIgNC44OSAyMS4xMSA0IDIwIDRaTTIwIDE4SDRWNkg4VjE4SDRWMTBIMjBWMThaTTEwIDEySDE2VjE0SDEwVjEyWk0xMCA4SDE2VjEwSDEwVjhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Pagos Realizados"
                :activo="getRoute() === 'GestionPagos'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionMensajesWhatsApp' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjQ3IDQuNzNDMTYuMDcgNC4yNCAxNC41MSA0IDEyLjk3IDRDNS45MyA0IDAuNTUgOS4yOSAwLjU1IDE2LjI5QzAuNTUgMTkuMDQgMS41NCAyMS41OCAzLjA0IDIzLjU4TDAgMjRMMy4xMiAyMC45MkMyLjA5IDE5LjYgMS41IDE4LjA1IDEuNSAxNi4yOUMxLjUgMTAuMTEgNi4xMSA1LjE0IDEyIDUuMTRDMTMuNDEgNS4xNCAxNC43OCA1LjM5IDE2LjA2IDUuODZMMTcuNDcgNC43M1pNMjMuNDUgMTYuMjdDMjMuNDUgMTguMDMgMjIuODYgMTkuNTggMjEuODMgMjAuOUwyNCAyNEwyMC44OCAyMC45MkMyMi4zOCAxOC45MiAyMy4zNyAxNi4zOCAyMy4zNyAxMy42M0MyMy4zNyA2LjY1IDE4IDAuNTUgMTIgMC41NUMxMC41NSAwLjU1IDkuMTggMC44IDcuOSAxLjI3TDYuNDkgMEM1LjA5IDAuNDkgMy41MyAwLjczIDEuOTkgMC43M0MwLjkyIDAuNzMgMCAxLjY1IDAgMi43MlYxNi4yN0MwIDE3LjM0IDAuOTIgMTguMjYgMS45OSAxOC4yNkMyLjYyIDE4LjI2IDMuMjIgMTguMTEgMy43NyAxNy44NEw0LjY2IDE4LjczTDMuNzcgMjEuNzJMMTYuNjYgOC44M0wxNS43NyA5LjcyQzE1LjIyIDkuNDcgMTQuNjIgOS4zMiAxMy45OSA5LjMyQzEyLjkyIDkuMzIgMTIgMTAuMjQgMTIgMTEuMzFWMTYuMjdDMTIgMTcuMzQgMTIuOTIgMTguMjYgMTMuOTkgMTguMjZIMjMuNDVWMTYuMjdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Mensajes WhatsApp"
                :activo="getRoute() === 'GestionMensajesWhatsApp'"
                @click="cerrar_menu"
              >
                <template #icon>
                  <i class="material-icons text-white" style="font-size: 24px; width: 24px;">chat</i>
                </template>
              </sidenav-item>
              <sidenav-item
                :to="{ name: 'GestionCitasCobranza' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjcxIDEwLjI5TDEzLjQxIDhMMTUuNzEgNS43MUwxNC4yOSA0LjI5TDEyIDYuNTlNOS43MSA0LjI5TDguMjkgNS43MUwxMC41OSA4TDguMjkgMTAuMjlNOS43MSAxMS43MUwxMiA5LjQxTDE0LjI5IDExLjcxTDE1LjcxIDEwLjI5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="
                text="Citas de Cobranza"
                :activo="getRoute() === 'GestionCitasCobranza'"
                @click="cerrar_menu"
              >
                <template #icon>
                  <i class="material-icons text-white" style="font-size: 24px; width: 24px;">event</i>
                </template>
              </sidenav-item>
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="canAccessPortalWeb" class="nav-item PortalWeb">
        <sidenav-collapse
          collapse-ref="portalweb"
          nav-text="Portal Web"
        >
          <template #icon>
            <i class="material-icons text-white">language</i>
          </template>
          <template #list>
            <ul class="nav pe-0 ms-3">
              <sidenav-item
                :to="{ name: 'NomencladoresBanners' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDNIMUMwLjQ1IDMgMCAzLjQ1IDAgNFYyMEMwIDIwLjU1IDAuNDUgMjEgMSAyMUgyM0MyMy41NSAyMSAyNCAyMC41NSAyNCAyMFY0QzI0IDMuNDUgMjMuNTUgMyAyMyAzSDIxWk0yMSA1SDIzVjE5SDIxVjVWMTlIMVY1SDIxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+"
                text="Banners"
                :activo="getRoute() === 'NomencladoresBanners'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'NomencladoresFAQs' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTMgMTlIMTFWMTdIMTNWMTlaTTE1LjA3IDExLjI1TDE0LjE3IDEyLjE3QzEzLjQ1IDEyLjkgMTMgMTMuNSAxMyAxNUgxMVYxNC41QzExIDEzLjY3IDExLjQ1IDEyLjkgMTIuMTcgMTIuMTdMMTMuMjcgMTEuMDdDMTMuNzIgMTAuNjIgMTQgMTAuMDYgMTQgOS41QzE0IDguNjcgMTMuMzMgOCAxMi41IDhDMTEuNjcgOCAxMSA4LjY3IDExIDkuNUg5QzkgNy44MyAxMC4xNyA2LjUgMTIgNi41QzEzLjgzIDYuNSAxNSA3LjY3IDE1IDkuNUMxNSAxMC4zNSAxNC42NyAxMS4xIDE0LjA3IDExLjI1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+"
                text="Preguntas Frecuentes"
                :activo="getRoute() === 'NomencladoresFAQs'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'GestionSucursales' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Sucursales"
                :activo="getRoute() === 'GestionSucursales'"
                @click="cerrar_menu"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="canAccessCatalogs" class="nav-item Nomencladores">
        <sidenav-collapse
          collapse-ref="nomencladores"
          nav-text="Nomencladores"
        >
          <template #icon>
            <i class="material-icons text-white">settings</i>
          </template>
          <template #list>
            <ul class="nav pe-0 ms-3">
              <sidenav-item
                :to="{ name: 'NomencladoresCategorias' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Categorías"
                :activo="getRoute() === 'NomencladoresCategorias'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'NomencladoresMarcas' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjkyIDYuMDFDMTguNzIgNS40MiAxOC4xNiA1IDE3LjUgNUg2LjVDNS44NCA1IDUuMjggNS40MiA1LjA4IDYuMDFMMyA5VjE5QzMgMTkuNTUgMy40NSAyMCA0IDIwSDUuMUM1LjY1IDIwIDYuMiAxOS41NSA2LjIgMTlWMTcuNUgxNy44VjE5QzE3LjggMTkuNTUgMTguMzUgMjAgMTguOSAyMEgyMEMyMC41NSAyMCAyMSAxOS41NSAyMSAxOVY5TDE4LjkyIDYuMDFaTTYuNSAxNS41QzUuNjcgMTUuNSA1IDE0LjgzIDUgMTRTNS42NyAxMi41IDYuNSAxMi41UzggMTMuMTcgOCAxNFM3LjMzIDE1LjUgNi41IDE1LjVaTTE3LjUgMTUuNUMxNi42NyAxNS41IDE2IDE0LjgzIDE2IDE0UzE2LjY3IDEyLjUgMTcuNSAxMi41UzE5IDEzLjE3IDE5IDE0UzE4LjMzIDE1LjUgMTcuNSAxNS41Wk0xOC45MiA2SDE3LjVMMTguOTIgNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
                text="Marcas"
                :activo="getRoute() === 'NomencladoresMarcas'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'NomencladoresModelos' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDNDMTguNDUgMyAxOCAzLjQ1IDE4IDRWMThDMTggMTguNTUgMTguNDUgMTkgMTkgMTlDMjAuMSAxOSAyMSAxOC4xIDIxIDE3VjRDMjEgMy40NSAyMC41NSAzIDE5IDNaTTE5IDVIMjFWN0gxOVY1Wk0xOSA5SDIxVjExSDE5VjlaTTE5IDEzSDIxVjE1SDE5VjEzWk0xOSAxN0gyMVYxN0gxOVYxN1pNNSAzQzQuNDUgMyA0IDMuNDUgNCA0VjE4QzQgMTguNTUgNC40NSAxOSA1IDE5QzYuMSAxOSA3IDE4LjEgNyAxN1Y0QzcgMy40NSA2LjU1IDMgNSAzWk01IDVIN1Y3SDVWNVpNNSA5SDdWMTFIMVY5Wk01IDEzSDdWMTVIMVYxM1pNNSAxN0g3VjE3SDVWMTdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Modelos"
                :activo="getRoute() === 'NomencladoresModelos'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'NomencladoresPaises' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Países"
                :activo="getRoute() === 'NomencladoresPaises'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'NomencladoresEstados' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Estados"
                :activo="getRoute() === 'NomencladoresEstados'"
                @click="cerrar_menu"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="canAccessReports" class="nav-item Reportes">
        <sidenav-item
          :to="{ name: 'Reportes' }"
          mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDNINUMzLjkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVY1QzIxIDMuOSAyMC4xIDMgMTkgM1pNMTkgMTlINVY1SDE5VjE5Wk03IDEwSDlWMTJIN1YxMFpNNyA2SDlWOEg3VjZaTTcgMTRIOVYxNkg3VjE0Wk0xMyAxMEgxN1YxMkgxM1YxMFpNMTMgNkgxN1Y4SDEzVjZaTTEzIDE0SDE3VjE2SDEzVjE0WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+"
          text="Reportes"
          :activo="getRoute() === 'Reportes'"
          @click="cerrar_menu"
        />
      </li>
      <li v-if="canAccessSecurity" class="nav-item Seguridad">
        <sidenav-collapse
          collapse-ref="seguridad"
          nav-text="Seguridad"
        >
          <template #icon>
            <img
              src="http://issyrental-store-prod.s3.us-east-1.amazonaws.com/Administracion/iconos/lock_open_white_24dp.svg">
          </template>
          <template #list>
            <ul class="nav pe-0 ms-3">
              <sidenav-item
                :to="{ name: 'Usuarios' }"
                mini-icon="http://issyrental-store-prod.s3.us-east-1.amazonaws.com/Administracion/iconos/account_circle.svg"
                text="Usuarios"
                :activo="getRoute() === 'Usuarios'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'Roles' }"
                mini-icon="http://issyrental-store-prod.s3.us-east-1.amazonaws.com/Administracion/iconos/assignment_ind.svg"
                text="Roles"
                :activo="getRoute() === 'Roles'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'Permisos' }"
                mini-icon="http://issyrental-store-prod.s3.us-east-1.amazonaws.com/Administracion/iconos/encrypted.svg"
                text="Permisos"
                :activo="getRoute() === 'Permisos'"
                @click="cerrar_menu"
              />
              <sidenav-item
                :to="{ name: 'Trazas' }"
                mini-icon="http://issyrental-store-prod.s3.us-east-1.amazonaws.com/Administracion/iconos/admin_panel_settings.svg"
                text="Trazas"
                :activo="getRoute() === 'Trazas'"
                @click="cerrar_menu"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li v-if="canAccessConfiguracion" class="nav-item Configuracion">
        <sidenav-collapse
          collapse-ref="configuracion"
          nav-text="Configuración"
        >
          <template #icon>
            <i class="material-icons text-white">settings</i>
          </template>
          <template #list>
            <ul class="nav pe-0 ms-3">
              <sidenav-item
                :to="{ name: 'ConfiguracionTasasCambio' }"
                mini-icon="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                text="Tasas de Cambio"
                :activo="getRoute() === 'ConfiguracionTasasCambio'"
                @click="cerrar_menu"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
import SidenavCollapseItem from "./SidenavCollapseItem.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { Permissions } from "@/utils/permissions";

export default {
  name: "SidenavList",
  components: {
    SidenavItem,
    SidenavCollapse,
    SidenavCollapseItem
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active",
      username: this.$store.state.username
    };
  },
  computed: {
    ...mapGetters(["tienePermiso", "hasPermission"]),
    canAccessSecurity() {
      return this.hasPermission(Permissions.MODULE_SECURITY_ACCESS);
    },
    canAccessVehicles() {
      return this.hasPermission(Permissions.MODULE_VEHICLES_ACCESS);
    },
    canAccessManagement() {
      return this.hasPermission(Permissions.MODULE_MANAGEMENT_ACCESS);
    },
    canAccessQuotes() {
      return this.hasPermission(Permissions.MODULE_QUOTES_ACCESS);
    },
    canAccessCatalogs() {
      return this.hasPermission(Permissions.MODULE_CATALOGS_ACCESS);
    },
    canAccessPortalWeb() {
      return this.hasPermission(Permissions.MODULE_CATALOGS_ACCESS) || this.hasPermission(Permissions.CATALOGS_CRUD);
    },
    canAccessReports() {
      return this.hasPermission(Permissions.MODULE_REPORTS_ACCESS);
    },
    canAccessConfiguracion() {
      return this.hasPermission(Permissions.SYSTEM_SETTINGS) || this.hasPermission(Permissions.MODULE_SECURITY_ACCESS);
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    cerrar_menu() {
      if (window.innerWidth < 550) {
        this.navbarMinimize();
      }
    },
    getRoute() {
      return this.$route.name
    },
    logout() {
      this.$store.state.isAuth = false;
      localStorage.clear();
      this.$router.push("/");
    }
  }
};

</script>
 <style scoped>
.bg-gradient-green1{
  background-color: #052e35;
}
 </style>